import _classCallCheck from "/Users/jason/WIP/2020/Archive/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/jason/WIP/2020/Archive/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jason/WIP/2020/Archive/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jason/WIP/2020/Archive/node_modules/@babel/runtime/helpers/esm/inherits";
export * from '@stickyroll/context';
export { ScrollConsumer as Listener } from '@stickyroll/context';
import { Frame } from '@stickyroll/frame';
export * from '@stickyroll/frame';

var Stickyroll =
/*#__PURE__*/
function (_Frame) {
  _inherits(Stickyroll, _Frame);

  function Stickyroll() {
    _classCallCheck(this, Stickyroll);

    return _possibleConstructorReturn(this, _getPrototypeOf(Stickyroll).apply(this, arguments));
  }

  return Stickyroll;
}(Frame);

export { Stickyroll };